
import { supabase } from "@/integrations/supabase/client";

/**
 * Service for depublishing interviews
 */
export class DepublishInterviewService {
  /**
   * De-publish an interview (move back to pending status)
   */
  static async depublishInterview(interviewId: string): Promise<boolean> {
    console.log('De-publishing interview:', interviewId);
    
    try {
      // Verify the current interview state before updating
      const { data: currentInterview, error: checkError } = await supabase
        .from('interviews')
        .select('id, publication_status')
        .eq('id', interviewId as any)
        .maybeSingle();
      
      if (checkError) {
        console.error('Error checking interview state:', checkError);
        throw new Error(`Failed to check interview state: ${checkError.message}`);
      }
      
      console.log('Current interview state:', currentInterview);
      
      if (!currentInterview) {
        console.error('Interview not found, cannot depublish');
        throw new Error('Interview not found');
      }
      
      // This is a direct RPC call to run SQL with elevated permissions
      // to ensure the update happens regardless of any row-level security
      const { data: rpcResult, error: rpcError } = await supabase.rpc(
        'depublish_interview' as any, 
        { interview_id: interviewId }
      );
      
      if (rpcError) {
        console.error('Error in depublish_interview RPC:', rpcError);
        throw new Error(`Failed to depublish interview via RPC: ${rpcError.message}`);
      }
      
      console.log('RPC depublish result:', rpcResult);
      
      if (!rpcResult) {
        console.error('Depublish operation failed with false result');
        throw new Error('Depublish operation failed');
      }
      
      // Verify the update was successful
      const { data: verifyData, error: verifyError } = await supabase
        .from('interviews')
        .select('publication_status')
        .eq('id', interviewId as any)
        .maybeSingle();
      
      if (verifyError) {
        console.error('Error verifying depublication:', verifyError);
        throw new Error(`Failed to verify depublication: ${verifyError.message}`);
      }
      
      console.log('Verification result:', verifyData);
      
      if (!verifyData || (verifyData as any)?.publication_status !== 'pending') {
        console.error('Depublication failed, status not updated properly:', (verifyData as any)?.publication_status);
        throw new Error('Failed to depublish interview: Status not updated');
      }
      
      console.log('Interview successfully depublished and removed from feeder');
      return true;
    } catch (err) {
      console.error('Error in depublishInterview:', err);
      throw err;
    }
  }
}
